<div class="under-18-modal">
  <div class="modal-header">
    <img src="assets/img/SG-logo-350px.png" alt="Statement Games" class="sg-logo" />
    <button type="button" class="close-btn" (click)="close()">&times;</button>
  </div>

  <div class="modal-body">
    <div class="lock-icon-wrapper">
      <div class="lock-icon-circle">
        <svg class="lock-icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      </div>
    </div>

    <h2 class="modal-title" *ngIf="!isIneligibleState && !isTerritoryRestriction && !isInternationalRestriction && !isCommissionerAgeIneligible">Sorry, You Must Be 18 To Go Pro</h2>

    <p class="modal-description" *ngIf="!isIneligibleState && !isTerritoryRestriction && !isInternationalRestriction && !isCommissionerAgeIneligible">
      You must be <strong>18 or older</strong> to become an <strong>SG Pro</strong> subscriber
      and compete for <strong>cash leaderboard rewards</strong>.
    </p>

    <h2 class="modal-title" *ngIf="isCommissionerAgeIneligible">Sorry, You Must Be 18 To Create a Private Contest</h2>

    <p class="modal-description" *ngIf="isCommissionerAgeIneligible">
      You must be <strong>18 or older</strong> to create and manage a <strong>Commissioner private contest</strong>.
    </p>

    <h2 class="modal-title" *ngIf="isIneligibleState || isInternationalRestriction">You've Reached Today's Free Play Limit</h2>

    <p class="modal-description" *ngIf="isIneligibleState || isInternationalRestriction">
      You've already enjoyed today's 2 free public contests. Based on your current location, additional public contests aren't available at this time. Check back tomorrow to enjoy 2 more free public contests.
    </p>

    <h2 class="modal-title" *ngIf="isTerritoryRestriction">Territory Restriction</h2>

    <p class="modal-description" *ngIf="isTerritoryRestriction">
      We detected that you are accessing from <strong>{{detectedStateName || detectedState || 'a restricted location'}}</strong>,
      which is not an eligible territory for Pro subscription play.<span *ngIf="stateName"> Your registered state is <strong>{{stateName}}</strong>.</span>
      Pro subscriptions are only available in specific territories.
      Please contact support if you believe this is an error.
    </p>

    <button 
      type="button" 
      class="btn-back-to-lobby" 
      (click)="onBackToLobby()"
    >
      Back to Gaming Lobby
    </button>

    <p class="footer-text" *ngIf="!isIneligibleState && !isInternationalRestriction && !isTerritoryRestriction && !isCommissionerAgeIneligible">
      Users under 18 can continue playing free Rookie contests daily
      but cannot upgrade to SG Pro.
    </p>

    <p class="footer-text" *ngIf="isCommissionerAgeIneligible">
      Users under 18 can continue playing free Rookie contests daily
      but cannot create Commissioner private contests.
    </p>
  </div>
</div>
